import React from 'react';

import Image from 'next/image';

import { useStores } from 'hooks/use-stores';

interface LoadingSpinnerProps {
    size?: number;
    height?: string;
    width?: string;
}

const LoadingSpinner = ({ size = 24, height = '100%', width = '100%' }: LoadingSpinnerProps): JSX.Element => {
    const { uiStore } = useStores();
    const dark = uiStore.colorPalette.currentColorPaletteLightOrDark === 'dark';

    return (
        <div
            data-testid={'loading-spinner'}
            style={{ width, height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
            <Image
                width={size}
                height={size}
                quality={100}
                src={`/images/loading/loading${dark ? '-dark' : ''}.png`}
                alt={'Loading...'}
                style={{ animation: 'spin 2s linear infinite', transform: 'scaleX(-1)' }}
            />
        </div>
    );
};

export default LoadingSpinner;
